import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { IDestinationProject } from '~src/projects/ServerApi/types/IDestinationProject';

export interface IGetDestinationProjectParams extends IGetItemsParams {
  contentType: string;
  sourceIds?: string[];
}

export interface IGetDestinationProjectsResult extends IGetItemsResult {
  projects: IDestinationProject[];
}

export class GetDestinationProjectsRequest
    extends Request<IGetDestinationProjectParams, IGetDestinationProjectsResult> {
  constructor(params: IGetDestinationProjectParams) {
    super('getDestinationProjects', params);
  }
}
